import { createFileRoute } from "@tanstack/react-router";
import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";
import { useSuspenseGraphQL } from "@/hooks/use-graphql.ts";
import {
  HeaderRoot,
  HeaderTitle,
  HeaderUpButton,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import { SecretaryDetailsFaqForm } from "@/components/assist/secretary-details/faq-form";

// biome-ignore lint/plugin/route-file-exports: predates the rule; move it out
export const GetSecretaryDetailsFaqQuery = graphql(/* GraphQL */ `
  query GetSecretaryDetailsFaqQuery {
    ...SecretaryDetailsFaqFormFragment
  }
`);

const ProfessionalInfosPage = (): React.ReactNode => {
  const { data } = useSuspenseGraphQL(GetSecretaryDetailsFaqQuery, {});
  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="" align="center" />
      </HeaderRoot>
      <Page>
        <SecretaryDetailsFaqForm data={data} />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/secretary-details/faq")({
  component: ProfessionalInfosPage,
  pendingComponent: () => <PendingComponent title="" />,
});
